// extracted by mini-css-extract-plugin
export var clearButton = "SearchBar-module--clearButton--f8712";
export var quickSearch = "SearchBar-module--quickSearch--7d66a";
export var quickSearchOpen = "SearchBar-module--quickSearchOpen--e0efd";
export var searchBar = "SearchBar-module--searchBar--97ee1";
export var searchBarInputContainer = "SearchBar-module--searchBarInputContainer--c79e9";
export var thin = "SearchBar-module--thin--1dfed";